import { Box, type BoxProps } from '@mantine/core'
import { clsx } from 'clsx'
import { type PropsWithChildren } from 'react'

import classes from './styles.module.css'

export function PageContent({
  children,
  className,
}: PropsWithChildren<BoxProps>) {
  const contentWrapperClasses = clsx(classes.pageContentWrapper, className)

  return (
    <Box className={contentWrapperClasses}>
      <Box className={classes.pageContent}>{children}</Box>
    </Box>
  )
}

PageContent.displayName = 'PageContent'
